
<notifier-container></notifier-container>
<router-outlet></router-outlet>
<div *ngIf="status"  class="fixed md:block z-[99999] w-[260px] md:w-[auto] bg-[#52c73f] p-2 md:p-4 rounded-[10px] right-10 top-2 flex items-center">
    <div class="flex gap-4 items-center relative">
        <div class="absolute hidden md:block -top-2 right-6">
            <img src="assets/images/close.svg" class="w-[25px] md:w-full" alt="close">
        </div>
        <div class="w-[40px] hidden md:flex h-[40px] md:w-[50px] p-3  justify-center items-center md:h-[50px] rounded-full bg-[#F5F5F5]">
            <img src="assets/images/ic_round-check.svg" alt="">
        </div>
        <div>
            <h6 class="text-[#F5F5F5] font-[800] text-base md:text-xl leading-8">Success!</h6>
            <p class=" text-[12px] md:text-base text-[#F5F5F5] font-normal">{{message}}</p>
        </div>
    </div>
</div>